/**
 * overlay.js is a reusable component.
 * initialize it in your module by passing the overlay dom object
 * and bind the showOverlay() function to one of your modules
 * elements
 */

import './overlay.scss';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

class Overlay {
    constructor ($overlay) {
        this.$overlay = $overlay;
        this.$close = this.$overlay.querySelector('[data-overlay="close"]');
        this.$siteMain = document.querySelector('.site-main');
        this.windowPosition = 0;
    }

    initialize () {
        if (!this.$overlay.classList.contains('initialized')) {
            this.$overlayScroller = this.$overlay.querySelector('[data-overlay="scroller"]');
            this.$overlay.classList.add('initialized');
            this.bindEvents();
        }
    }

    bindEvents () {
        if (this.$close) {
            this.$close.addEventListener('click', () => {
                this.hideOverlay();
            });
        }
    }

    showOverlay () {
        this.$overlay.classList.add('overlay--visible');

        if (!window.browser.csshover) {
            disableBodyScroll(this.$overlayScroller);
        }

        if (this.$siteMain) {
            this.$siteMain.classList.add('site-main--overlay');
        }
    }

    hideOverlay () {
        this.$overlay.classList.remove('overlay--visible');

        if (!window.browser.csshover) {
            clearAllBodyScrollLocks();
        }

        if (this.$siteMain) {
            this.$siteMain.classList.remove('site-main--overlay');
        }
    }
}

export { Overlay };
